export const ImageAspectRatio = Object.freeze({
    LETTERS: 1,
    PROFILE: 1,
    SUPPORT_SQUAD: 1,
});
